/**
 * @generated SignedSource<<6135257c8df94a440f547d327ee53e8c>>
 * @relayHash c82cedffd514ace9062cc5a7ea29b433
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190

import type { ConcreteRequest } from 'relay-runtime';
export type useDynamicSplitButtonContentHistoryQuery$variables = {
  contentId: string;
};
export type useDynamicSplitButtonContentHistoryQuery$data = {
  readonly contentHistory: {
    readonly nodes: ReadonlyArray<{
      readonly collaborators: {
        readonly userAccountIds: ReadonlyArray<string | null>;
      } | null;
    } | null> | null;
  } | null;
};
export type useDynamicSplitButtonContentHistoryQuery = {
  response: useDynamicSplitButtonContentHistoryQuery$data;
  variables: useDynamicSplitButtonContentHistoryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "PaginatedContentHistoryList",
    "kind": "LinkedField",
    "name": "contentHistory",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentHistory",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "concreteType": "ContributorUsers",
            "kind": "LinkedField",
            "name": "collaborators",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "userAccountIds"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useDynamicSplitButtonContentHistoryQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useDynamicSplitButtonContentHistoryQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c82cedffd514ace9062cc5a7ea29b433",
    "id": "7dd5a60846b03a6eacef04466d72dec90722d2cae751b0c9b97f555a408d7190",
    "metadata": {},
    "name": "useDynamicSplitButtonContentHistoryQuery",
    "operationKind": "query",
    "text": "query useDynamicSplitButtonContentHistoryQuery($contentId:ID!){contentHistory(contentId:$contentId,first:1){nodes{collaborators{userAccountIds}}}}"
  }
};
})();

(node as any).hash = "428e55c833e4f9ecc04af6435214d702";

export default node;
